import React from 'react';

import { CMSBanner, CMSReference, useCMSReference } from '@swf/cms';
import type { Meta, Reference } from '@swf/generated/cms/types';

import styles from '../CMSRotator.scss';

interface Props {
  item: Reference;
}

const CMSRotatorItem: React.FC<Props> = ({ item }) => {
  const { banner, body } = useCMSReference<Meta>(item) as Meta;
  return (
    <>
      {banner && <CMSBanner {...banner} />}
      <div className={styles.contentWrapper}>
        {body?.map((item, itemIndex) => (
          <CMSReference key={itemIndex} {...item} />
        ))}
      </div>
    </>
  );
};

export default CMSRotatorItem;
